import { render, staticRenderFns } from "./dau_mau.vue?vue&type=template&id=5573cc83&scoped=true&"
import script from "./dau_mau.vue?vue&type=script&lang=js&"
export * from "./dau_mau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5573cc83",
  null
  
)

export default component.exports